import React, { useState, useEffect } from 'react';

import { withRouter } from '@atlassian/react-resource-router';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { fetchApplinks } from '../../rest/index.tsx';
import type { ApplicationLinkV3Data } from '../../common/entities.tsx';
import ApplinksPageContents from './main.tsx';

export const ApplinksPage = () => {
	const [applinks, setApplinks] = useState<ApplicationLinkV3Data[] | null>(null);

	useEffect(() => {
		fetchApplinks()
			.then((data) => {
				setApplinks(data);
			})
			.catch((err) => {
				const maybeError = err instanceof Error ? err : undefined;
				log.safeErrorWithoutCustomerData(
					'applinks.administration.list.loadApplinks',
					'Failed to load applinks for the list page',
					maybeError,
				);
				setApplinks(null);
			});
	}, []);

	return <ApplinksPageContents applinks={applinks} />;
};

export default withRouter(ApplinksPage);
